var $name="capArrayIndex",$path="app/utilities/capArrayIndex.js",$this={$name,$path,};function capArrayIndex(index, { length }) {
  if (index >= length) return 0;
  if (index < 0) return length - 1;
  return index;
}

export default capArrayIndex;
